export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'TAG',
      path: 'tag',
      get: { active: true, msg: '' },
      update: { active: false, msg: '' },
      create: { active: false, msg: '' },
      delete: { active: false, msg: '' },
      admin: {
        get: { active: true, msg: '' },
        update: { active: true, msg: 'Tags aktualisiert.' },
        create: { active: true, msg: 'Tag erstellt.' },
        delete: { active: true, msg: 'Tag gelöscht.', rtr: 'AllTags' },
      },
    },
  },
  getters: {
    dataById: (state) => (id) => state.data[id],
  },
  mutations: {},
  actions: {
    SOCKET_TAGS({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_TAGS`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      // commit('SET_LOADING', false);
    },
  },
};
